var React = require('react');

function CircleHalfFilled12x12 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 1a5 5 0 000 10z","fill":"currentColor","key":0}),React.createElement("circle",{"cx":"6","cy":"6","r":"5","stroke":"currentColor","strokeWidth":"2","fill":"none","key":1})]);
}

CircleHalfFilled12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = CircleHalfFilled12x12;

CircleHalfFilled12x12.default = CircleHalfFilled12x12;
